module.exports = __webpack_public_path__ + "static/logo30-75267145a2e57c17ddb53a0f5da83254.png";